import { noop } from "nodash"
import { createContext, FC, useContext } from "react"

export const TopBarContext = createContext<{
    register: (config: TopBarConfig) => void
    unregister: (key: string) => void
}>({ register: noop, unregister: noop })

export const useTopBarRegistry = () => {
    return useContext(TopBarContext)
}

export interface TopBarConfig {
    Item: FC
    key: string
    cleanup?: () => void
    options?: { resizable?: boolean }
}
